export default __webpack_public_path__ + "static/media/project2.472dce2a.png";